import api from "./client";

export async function getSettings() {
  const { data } = await api.get("/api/site-meta/settings");
  return data;
}

export async function updateSettings(payload) {
  const { data } = await api.put("/api/site-meta/settings", payload);
  return data;
}
